$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    const $section = $('section#contact');
    const $thanks = $section.find('.page-thank-you');

    // Pin the box to the height the form occupied: the message is far shorter, and both share the
    // same green splash, so without this the box (and the packshot pinned to its corner) would
    // jump upward on the swap. Measured before hiding — a hidden element reports 0.
    $thanks.css('min-height', $section.find('.page-form').outerHeight() + 'px');

    // Page swap instead of a modal: the form gives way to the thank-you block already in the
    // markup (templates/contact/_form.html.twig) — same scheme as the winner section.
    $section.find('.page').addClass('d-none');
    $thanks.removeClass('d-none');
});

// "POWRÓT" — a full reload rather than swapping the form back in: it restores a pristine form
// with a fresh CSRF token and idempotency key.
$(document).on('click', '.contact-thanks-back', function() {
    window.location.reload();
});
